exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* Shadows are intentionally very subtle gradiations. */\n.EmptyState-EmptyState_tZfb4 {\n  margin-top: 20px;\n  margin-bottom: 20px; }\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/EmptyState/EmptyState.scss"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,iBAAiB;EACjB,oBAAoB,EAAE","file":"EmptyState.scss","sourcesContent":["/* Shadows are intentionally very subtle gradiations. */\n.EmptyState {\n  margin-top: 20px;\n  margin-bottom: 20px; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"EmptyState": "EmptyState-EmptyState_tZfb4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]-[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./src/assets/scss/base.scss","./src/assets/scss/helpers.scss"]}!./src/components/EmptyState/EmptyState.scss
// module id = 1605
// module chunks = 0